const o=.0025;export{o as MIN_FEE};
//# sourceMappingURL=tieredPricing.js.map
